export const DBAAS_SUBSCRIPTION_RESET_STATE = 'DBAAS_SUBSCRIPTION_RESET_STATE';
export const DBAAS_SUBSCRIPTION_CURRENT_ITEM = 'DBAAS_SUBSCRIPTION_CURRENT_ITEM';

export const DBAAS_SUBSCRIPTION_REQUEST_LOADING = 'DBAAS_SUBSCRIPTION_REQUEST_LOADING';
export const DBAAS_SUBSCRIPTION_REQUEST_SUCCESS = 'DBAAS_SUBSCRIPTION_REQUEST_SUCCESS';
export const DBAAS_SUBSCRIPTION_REQUEST_FAILED = 'DBAAS_SUBSCRIPTION_REQUEST_FAILED';

export const DBAAS_SUBSCRIPTION_CURRENT_ACTION = 'DBAAS_SUBSCRIPTION_CURRENT_ACTION';
export const DBAAS_SUBSCRIPTION_RESET_ACTION = 'DBAAS_SUBSCRIPTION_RESET_ACTION';